module.exports = __webpack_public_path__ + "static/img/3.689603ee.jpg";